import _axios from 'axios';
import { includes } from 'lodash';

export const BASE_URL = process.env.REACT_APP_API_URL || '';

const getCSRFToken = (): string | undefined =>
  document.cookie
    .split('; ')
    .find((row) => row.startsWith('csrftoken='))
    ?.split('=')[1];

export const axios = _axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

axios.interceptors.request.use((config) => {
  const csrfToken = getCSRFToken();

  if (
    csrfToken &&
    includes(['post', 'put', 'patch', 'delete'], config.method || '')
  ) {
    config.headers['X-CSRFToken'] = csrfToken;
  }

  return config;
});
